import { connect } from 'react-redux'
import BillingBankAccountRow from './BillingBankAccountRow'
import showBillingAddBankAccountFormModal from '../BillingAddBankAccountFormModal'

const stateToProps = () => ({})

const dispatchToProps = {
  showBillingAddBankAccountFormModal,
}

export default connect(stateToProps, dispatchToProps)(BillingBankAccountRow)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingBankAccountRow/BillingBankAccountRow.container.js